import styled from "styled-components";

export const PageLayout = styled.div `
    display: ${( props ) => props.display};
    flex-direction: ${( props ) => props.flexDirection};
    /* column, could use flex numbers instead? */
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px 0px 0px 0px;
`